"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var myAccount_1 = require("../../../../../common/constants/myAccount");
var useWidgetContext_1 = require("../../../../../common/react/useWidgetContext");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var myAccountChangeDetailsCtaStyles_1 = require("./myAccountChangeDetailsCtaStyles");
var MyAccountChangeDetailsCta = function (_a) {
    var refetchEnquiryForm = _a.refetchEnquiryForm;
    var myAccountUrl = useWidgetContext_1.default().configuration.myAccountUrl;
    var styles = myAccountChangeDetailsCtaStyles_1.default();
    var _b = react_1.useState(false), showRefetchCta = _b[0], setShowRefetchCta = _b[1];
    var translationId = showRefetchCta
        ? 'trans__checkout__next_step__customer_information__refresh_cta'
        : 'trans__checkout__next_step__customer_information__change_detail_cta';
    var handleButtonClick = function () {
        if (showRefetchCta) {
            refetchEnquiryForm();
        }
        else {
            window.open(myAccount_1.getPersonalDetailsUrl(myAccountUrl), '_blank');
            setShowRefetchCta(true);
        }
    };
    return (<core_1.Button className={styles.root} onClick={handleButtonClick} data-test={"checkout:myaccount:change-details" + (showRefetchCta ? '-refetch' : '') + "-cta"}>
      <Translation_1.default id={translationId} className={styles.text}/>
    </core_1.Button>);
};
exports.default = MyAccountChangeDetailsCta;
